<!-- 机构编辑弹窗 -->
<template>
  <el-dialog
    :title="isUpdate?'修改机构':'添加机构'"
    :visible="visible"
    width="600px"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    @update:visible="updateVisible">
    <el-form
      :model="form"
      ref="form"
      :rules="rules"
      label-width="82px">
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="上级机构:">
            <treeselect
              v-model="form.pid"
              :options="deptList"
              placeholder="请选择上级机构"
              :defaultExpandLevel="4"
              :normalizer="normalizer"/>
          </el-form-item>
          <el-form-item
            label="机构名称:"
            prop="name">
            <el-input
              :maxlength="20"
              v-model="form.name"
              placeholder="请输入机构名称"
              clearable/>
          </el-form-item>
          <el-form-item
            label="机构全称:"
            prop="fullname">
            <el-input
              :maxlength="100"
              v-model="form.fullname"
              placeholder="请输入机构全称"
              clearable/>
          </el-form-item>
          <el-form-item
            label="机构代码:"
            prop="code">
            <el-input
              :maxlength="20"
              v-model="form.code"
              placeholder="请输入机构代码"
              clearable/>
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item
            label="机构类型:"
            prop="type">
            <el-select
              v-model="form.type"
              placeholder="请选择机构类型"
              class="ele-fluid"
              clearable>
              <el-option
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item
            label="排序号:"
            prop="sort">
            <el-input-number
              v-model="form.sort"
              controls-position="right"
              :min="0"
              :max="99999"
              placeholder="请输入排序号"
              class="ele-fluid ele-text-left"/>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input
              :maxlength="200"
              v-model="form.note"
              placeholder="请输入备注"
              :rows="4"
              type="textarea"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button
        @click="updateVisible(false)">取消
      </el-button>
      <el-button
        type="primary"
        @click="save"
        :loading="loading">保存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'OrgEdit',
  components: {Treeselect},
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 修改回显的数据
    data: Object,
    // 全部机构
    deptList: Array
  },
  data() {
    return {
      // 表单数据
      form: Object.assign({}, this.data, {
        pid: this.data ? (this.data.pid === 0 ? null : this.data.pid) : null
      }),
      // 表单验证规则
      rules: {
        name: [
          {required: true, message: '请输入机构名称', trigger: 'blur'}
        ],
        fullname: [
          {required: true, message: '请输入机构全称', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入机构代码', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请选择机构类型', trigger: 'blur'}
        ],
        sort: [
          {required: true, message: '请输入排序号', trigger: 'blur'}
        ]
      },
      // 提交状态
      loading: false,
      // 是否是修改
      isUpdate: false,
      // 机构类型列表
      typeList: []
    };
  },
  watch: {
    data() {
      if (this.data) {
        this.form = Object.assign({}, this.data, {
          pid: this.data.pid === 0 ? null : this.data.pid
        });
        this.isUpdate = !!this.data.id;
      } else {
        this.form = {};
        this.isUpdate = false;
      }
    }
  },
  mounted() {
    this.queryOrgType();  // 获取机构类型
  },
  methods: {
    /* 下拉树组件格式化数据 */
    normalizer(d) {
      return {
        id: d.id,
        label: d.name
      };
    },
    /* 保存编辑 */
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http.post('/dept/edit',
            Object.assign({}, this.form, {
              pid: this.form.pid || 0
            })
          ).then(res => {
            this.loading = false;
            if (res.data.code === 0) {
              this.$message.success(res.data.msg);
              if (!this.isUpdate) {
                this.form = {};
              }
              this.updateVisible(false);
              this.$emit('done');
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    /* 更新visible */
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    /* 查询机构类型 */
    queryOrgType() {
      this.$http.get('/dictdata/getDictByCode', {
        params: {
          code: 'organization_type'
        }
      }).then(res => {
        if (res.data.code === 0) {
          this.typeList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    }
  }
}
</script>

<style scoped>
</style>
